import { AssetTracksResponse, useGetAssetTracksQuery } from '@casops/store/apis/assetTracksApi';
import { useAppSelector } from '@casops/store/hooks';
import { AssetTrackRecord } from '@casops/store/slices/assetTracksSlice';
import { skipToken } from '@reduxjs/toolkit/query';
import { DateTime } from 'luxon';

interface UseAssetTrackProps {
  trackId: string;
}

interface UseAssetTrackReturn {
  trackRecord: AssetTrackRecord | undefined;
  isTrackRecordValid: boolean;
  data: AssetTracksResponse | undefined;
  isSuccess: boolean;
  isError: boolean;
}

export const useAssetTrack = ({ trackId }: UseAssetTrackProps): UseAssetTrackReturn => {
  const trackRecord = useAppSelector<AssetTrackRecord | undefined>(
    state => state.assetTracks.tracks[trackId],
  );

  const isTrackRecordValid =
    !!trackRecord &&
    DateTime.fromISO(trackRecord.startTime).isValid &&
    DateTime.fromISO(trackRecord.endTime).isValid;

  const { data, isSuccess, isError } = useGetAssetTracksQuery(
    !isTrackRecordValid
      ? skipToken
      : {
          trackId,
          query: {
            assetId: trackRecord.assetId,
            timeRangeStart: trackRecord.startTime,
            timeRangeEnd: trackRecord.endTime,
          },
        },
    { refetchOnMountOrArgChange: 900 }, // Cache data for 15 minutes
  );

  return {
    trackRecord,
    isTrackRecordValid,
    data,
    isSuccess,
    isError,
  };
};
